import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { EntityProjectBrowser } from '@/components/entity/EntityProjectBrowser';

const SearchProjects = () => {
  return (
    <MainLayout>
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground mb-2">Search Carbon Projects</h1>
          <p className="text-muted-foreground">
            Discover and evaluate carbon offset projects from verified registries
          </p>
        </div>

        {/* Use the same EntityProjectBrowser component for consistency */}
        <EntityProjectBrowser />
      </div>
    </MainLayout>
  );
};

export default SearchProjects;